<template>

    <v-modal title="Email" fullscreen>

        <template #body>
            <v-builder :mode="campaign.type" :action="action" />
        </template>

        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="cancel">Cancel</v-button>
            <v-button size="sm" :loading="loading" @click.native="saveAction">Save</v-button>
        </template>

    </v-modal>

</template>

<script>

import ActionApi from '@api/ActionApi';
import BuilderUtil from '@builder/utils/BuilderUtil';
import ModalActionMixin from '@mixins/ModalActionMixin';

export default {

    mixins: [ModalActionMixin],

    computed: {

        campaign() {
            return this.$store.getters['campaign/campaign'];
        },

    },

    methods: {

        saveAction() {
            this.loading = true;
            BuilderUtil.saveBlocks();
            let action = this.$store.getters['builder/action'];
            ActionApi.updateAction(this.action.id, action)
                .then((response) => {
                    this.loading = false;
                    this.$store.commit('campaign/setAction', response.data.data);
                    this.$store.commit('setAlertSuccess', this.$t('message.saved'));
                    this.$store.commit('showModal', false);
                })
                .catch((error) => {
                    this.loading = false;
                    this.$store.commit('setAlertWithError', error);
                });
        },

    },

}

</script>
